/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Show_LessInputs */

const en_svc_show_less = /** @type {(inputs: Svc_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show less`)
};

const ar_svc_show_less = /** @type {(inputs: Svc_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض أقل`)
};

const bn_svc_show_less = /** @type {(inputs: Svc_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কম দেখুন`)
};

const de_svc_show_less = /** @type {(inputs: Svc_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weniger anzeigen`)
};

const es_svc_show_less = /** @type {(inputs: Svc_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar menos`)
};

const fr_svc_show_less = /** @type {(inputs: Svc_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher moins`)
};

const pt_svc_show_less = /** @type {(inputs: Svc_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar menos`)
};

const zh_svc_show_less = /** @type {(inputs: Svc_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收起`)
};

const tr_svc_show_less = /** @type {(inputs: Svc_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha az göster`)
};

const ru_svc_show_less = /** @type {(inputs: Svc_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать меньше`)
};

const pl_svc_show_less = /** @type {(inputs: Svc_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż mniej`)
};

/**
* | output |
* | --- |
* | "Show less" |
*
* @param {Svc_Show_LessInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_show_less = /** @type {((inputs?: Svc_Show_LessInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Show_LessInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_show_less(inputs)
	if (locale === "bn") return bn_svc_show_less(inputs)
	if (locale === "de") return de_svc_show_less(inputs)
	if (locale === "es") return es_svc_show_less(inputs)
	if (locale === "fr") return fr_svc_show_less(inputs)
	if (locale === "pt") return pt_svc_show_less(inputs)
	if (locale === "zh") return zh_svc_show_less(inputs)
	if (locale === "tr") return tr_svc_show_less(inputs)
	if (locale === "ru") return ru_svc_show_less(inputs)
	if (locale === "pl") return pl_svc_show_less(inputs)
	return en_svc_show_less(inputs)
});